import {IApiPermission, IPermission} from './IPermission'

class Transformer {
    static transform (data: IApiPermission, userId: number): IPermission {
        return {
            name: data.name,
            active: data.active,
            userId: userId
        }
    }

    static reverseTransform (permission: IPermission): IApiPermission {
        return {
            name: permission.name,
            active: permission.active,
        }
    }
}

export default Transformer
